import React from "react";

import { useGetDag } from "api/api-hooks/airflow-hooks";
import { Card } from "primereact/card";
import { useParams, useSearchParams } from "react-router-dom";
import AirflowTaskTable from "./components/AirflowTaskTable";

const AirflowTasks: React.FC = () => {
  const { dagId } = useParams();
  const [searchParams] = useSearchParams();
  const { data, isLoading } = useGetDag(dagId ?? "");
  const search = searchParams.get("search") || "";

  if (!dagId) return null;

  const filteredTasks = (data?.tasks ?? []).filter(
    task => !search || task.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Card title={`Airflow DAG: ${data?.title}`}>
      <AirflowTaskTable tasks={filteredTasks} dag={data} loading={isLoading} />
    </Card>
  );
};

export default AirflowTasks;
